import { Box, CloseButton } from '@mantine/core'

import { cn } from 'src/utils'

const tagVariants = {
  primary: 'bg-doubleNickel-gray-100 text-doubleNickel-gray-700',
  secondary:
    'bg-doubleNickel-brand-25 text-doubleNickel-brand-500 stroke-doubleNickel-brand-400',
  error: 'bg-doubleNickel-error-50 text-doubleNickel-error-500',
  success: 'bg-doubleNickel-success-100 text-doubleNickel-success-700',
  warning: 'bg-doubleNickel-warning-50 text-doubleNickel-warning-600',
  transparent: 'bg-transparent text-doubleNickel-gray-700',
  outline:
    'border border-doubleNickel-gray-300 text-doubleNickel-gray-700 bg-transparent',
}

const Tag = ({
  size = 'sm',
  variant = 'primary',
  showCloseButton = true,
  clickable = false,
  onClose = () => {},
  children,
  className = '',
  // text-nowrap sets text-wrap: nowrap. Passing a whitespace-* class later
  // does not remove it, so long labels need this to wrap inside a cell.
  wrap = false,
  ...props
}) => {
  return (
    <Box
      className={cn(
        'flex flex-row items-center gap-1 rounded bg-doubleNickel-gray-100 text-xs font-medium capitalize text-doubleNickel-gray-700', // pragma: allowlist secret
        wrap ? 'whitespace-normal text-wrap' : 'text-nowrap',
        clickable && 'cursor-pointer hover:opacity-80',
        size === 'xs' ? 'px-2 py-1' : 'p-2',
        tagVariants[variant],
        className
      )}
      {...props}
    >
      {children}
      {showCloseButton && (
        <CloseButton
          size={'xs'}
          onClick={(e) => {
            e.stopPropagation()
            onClose()
          }}
        />
      )}
    </Box>
  )
}

export default Tag
